module.exports = __webpack_public_path__ + "static/media/logo_black.f8d5cecf.svg";